export default [
  {
    path: '/keyword-lists',
    name: 'keyword-lists',
    meta: {
      metaTags: [
        {
          content: 'Organize and manage keyword research for better SEO planning.',
          name: 'description',
        },
        {
          page_slug: 'keyword-lists',
        },
      ],
      requiresAuth: true,
      title: 'eRank — Keyword Lists',
    },
    component: () => import('@/modules/keyword-lists/pages/Entry.vue'),
  },
  {
    path: '/keyword-lists/tags',
    redirect: to => {
      // Preserve query params when redirecting from old URL
      return {
        path: '/keyword-lists',
        query: to.query,
      };
    },
  },
];
